import { render } from "./LoginPasswordForm.vue?vue&type=template&id=dcd38c76&ts=true"
import script from "./LoginPasswordForm.vue?vue&type=script&lang=ts"
export * from "./LoginPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "/jenkins-tmp/workspace/Recruiting-PP6/Oidcserver/development@2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__